import App from './App.vue'
import VueJWT from 'vuejs-jwt'
import Affix from 'vue-affix';
import VueObserveVisibility from 'vue-observe-visibility'
import VueScrollTo from 'vue-scrollto'
import VueIntro from 'vue-introjs'
import VTooltip from 'v-tooltip'
import VueCookie from 'vue-cookie'

import VueD3 from 'vue-d3'
import 'intro.js/introjs.css'

import Bus from './event'
import BootstrapVue from "bootstrap-vue";
import VueYoutube from 'vue-youtube'

export default {
  install(Vue) {
    Vue.use(VueScrollTo, {
      offset: -50,
    })
    Vue.use(Affix);
    Vue.use(VueJWT, {})
    Vue.use(VueScrollTo)
    Vue.use(VueD3)
    Vue.use(VueObserveVisibility)
    Vue.use(Bus)
    Vue.use(BootstrapVue)
    Vue.use(VueIntro)
    Vue.use(VTooltip)
    Vue.use(VueCookie)
    Vue.use(VueYoutube)
    Vue.component('microba-results', App)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@microbadevs/report/src/main.js
// module id = c1Jc
// module chunks = 0